import { MeasurementSystem } from 'spw-components/unit-conversion/types';
import { IAppState } from 'spw-redux/reducer';
import { selectCurrentOrganization } from '../organization/selectors';

export const currentUser = (state: IAppState) => state.userReducer.user;

export const selectUserAvatarUpdatedAt = (state: IAppState) =>
  state.userReducer.userAvatarTimestamp;

export const selectMeasurementSystem = (state: IAppState) => {
  const organization = selectCurrentOrganization(state);

  return organization?.hasAccessToUnitConversion
    ? state.userReducer.user?.settings?.measurementSystemWeb ??
        MeasurementSystem.imperial
    : MeasurementSystem.imperial;
};
